import { render, staticRenderFns } from "./vpsBackups.vue?vue&type=template&id=e791f32a&scoped=true"
import script from "./vpsBackups.vue?vue&type=script&lang=js"
export * from "./vpsBackups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e791f32a",
  null
  
)

export default component.exports